
const routes = [
    {
        name: 'listarAtributosAtendimentos',
        path: 'atributos',
        alias: 'atributos/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarAtributoAtendimento',
        path: 'atributos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarAtributoAtendimento',
        path: 'atributos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarAtributoAtendimento',
        path: 'atributos/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
   
]

export default routes
